import { render, staticRenderFns } from "./agreementDoctor.vue?vue&type=template&id=76199a5c&scoped=true&"
import script from "./agreementDoctor.vue?vue&type=script&lang=js&"
export * from "./agreementDoctor.vue?vue&type=script&lang=js&"
import style0 from "./agreementDoctor.vue?vue&type=style&index=0&id=76199a5c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76199a5c",
  null
  
)

export default component.exports